import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Loader91 from 'loader91';
import Toast from 'vue2-toast';
import 'vue2-toast/lib/toast.css';
import store from './store';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import i18n from './i18n';
import './assets/scss/reset.scss';

import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client';

window._AI = {};
window.__native_money91 = {};

Vue.use(require('vue-moment'));
Vue.prototype.axios = axios;
Vue.use(require('vue-moment'));
Vue.use(Loader91);
Vue.use(VueCookies);
Vue.use(Toast, {
  defaultType: 'center',
  duration: 2000,
  wordWrap: true,
  width: '400px',
});

Vue.config.productionTip = false;

window.serverUrl = '/';
if (window.location.hostname == 'localhost')
  window.serverUrl = 'http://localhost:7777/';

// var options = {
//   transports: ['websocket'],
//   pingInterval:10000,
//   pingTimeout:10000
// }

// Vue.use(
//   new VueSocketIO({
//     debug: false,
//     vuex: {
//       store,
//       actionPrefix: 'SOCKET_',
//       mutationPrefix: 'SOCKET_',
//     },
//     connection:
//       window.location.hostname == 'localhost'
//         ? SocketIO('http://localhost:5001/', options)
//         : SocketIO('/', options),
//   })
// );

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
